import { objectToEnumMap } from './enum-helper';

export var PREDEFINED_TYPE = 'predefined';

/**
 * Предустановленные размеры
 * @type {Object}
 */
export var PREDEFINED_SIZE = {
    wrapContent: 'wrap_content',
    matchParent: 'match_parent',
    matchViewport: 'match_viewport'
};

var AVAILABLE_PREDEFINED_SIZE = objectToEnumMap(PREDEFINED_SIZE);

/**
 * Предуставновленный размер
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-predefined-size.json
 * @param {String} data.value
 * @param {PredefinedSize} defaultValue
 * @return {Object}
 */
export default (function (data) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!data || data.type !== PREDEFINED_TYPE) {
        return defaultValue;
    }

    if (AVAILABLE_PREDEFINED_SIZE.has(data.value)) {
        return predefinedSizeFactory(data.value);
    }

    return defaultValue;
});

export var predefinedSizeFactory = function predefinedSizeFactory(value) {
    return {
        value: value,
        type: PREDEFINED_TYPE
    };
};

export var MATCH_PARENT = predefinedSizeFactory(PREDEFINED_SIZE.matchParent);

export var WRAP_CONTENT = predefinedSizeFactory(PREDEFINED_SIZE.wrapContent);

export var MATCH_VIEWPORT = predefinedSizeFactory(PREDEFINED_SIZE.matchViewport);